import React, { useState, useEffect} from "react";
import axios from "axios";
import Header from "../../components/header";
import Sidebar from "../../components/sidebar";
import { useNavigate } from 'react-router-dom';

const Service = () => {
    
    const userID = sessionStorage.getItem("TRCUserId");
	const userEmail = sessionStorage.getItem("TRCUserEmail");
	const userName = sessionStorage.getItem("TRCUserName");
	const userPosition = sessionStorage.getItem("TRCUserPosition");

    const [allCratesData, setAllCratesData] = useState(null);
    const [cratesData, setCratesData] = useState(null);
    const [crates, setCrates] = useState(null);
    const [date, setDate] = useState(null);

    
    const getCrates = async () => {
        try{
            const response = await axios.get('https://api.trucoo.in/crates/manage/', {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            //console.log(response.data);

            if(response.data.status === 'success'){
                setCratesData(response.data.data);
                setAllCratesData(response.data.data);

                response?.data?.data?.forEach(data=> {
                    setCrates(prevCrates => ({...prevCrates, [data.id]: parseFloat(data?.cratesIn) > 0 ?parseFloat(data?.cratesIn) : 0}));
                })
            }

        }catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

    const updateCrates = async(id) => {
        const sendData = {
            crates: crates[id],
            id: id
        };

        try{
            const response = await axios.post('https://api.trucoo.in/crates/manage/', sendData, {
				headers: {
					'Content-Type': 'application/json',
					'X-API-KEY': 'erpTrucoo'
				}
			});

            //console.log(response.data);

            if(response.data.status === 'success'){
                getCrates();
            }

        }catch (error) {
			console.error("Error:", error.response || error.message);
		}
    };

    const handleChange = (e, id) => {
        const newValue = e.target.value;
        setCrates({...crates,[id]: newValue});
    };

    useEffect(() => {
        getCrates();
    },[]);

    const filterDate = (e) => {
        
        const date = e.target.value;
        const newDate = new Date(date);
        if (isNaN(newDate)) {
            console.error("Invalid date format");
            return;
        }
    
        const formattedDate = `${newDate.getFullYear()}/${String(newDate.getMonth() + 1).padStart(2, '0')}/${String(newDate.getDate()).padStart(2, '0')}`;
    
        const newCrates = allCratesData?.filter(crate => crate.date === formattedDate);
    
        newCrates?.forEach(data => {
            setCrates(prevCrates => ({
                ...prevCrates,
                [data.id]: parseFloat(data?.cratesIn) > 0 ? parseFloat(data?.cratesIn) : 0
            }));
        });
    
        setCratesData(newCrates);
    };
    

    return(

        <>
        <Header />
        <Sidebar />


        <div class="content-wrapper">
		<div class="container-full">
		
			<section class="content">
                <div class="box">
                    <div class="box-header with-border">
				        <h4 class="box-title">Crates</h4>
				        <p class="mb-0 box-subtitle">Crates Manage</p>
                        <input type='date' class="form-control" style={{width: '200px', float: 'right', marginTop: '-40px'}} value={date} onChange={filterDate} />
				    </div>
                    <div class="box-body">
                        <div class="row">
                            <div class="col-lg-12 mt-4">
                                <div className="table-responsive ">
                                    <table className="table table-bordered">
                                        <thead>
                                            <tr className="fs-12 fw-600 text-dark">
                                                <th>S.No</th>
                                                <th>Date</th>
                                                <th>Dealer</th>
                                                <th>Customer</th>
                                                <th>Crates out</th>
                                                <th colSpan={2}>Crates In</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {cratesData?.length > 0 ? 
                                            cratesData?.map((data, index) =>
                                            <tr className="fw-400 text-gray-600  fs-12" key={data.id}>
                                                <td>{index+1}</td>
                                                <td>{data.date}</td>
                                                <td>{data.dealerData.dealer}</td>
                                                <td>{data.dealerData.name}</td>
                                                <td>{data.cratesOut}</td>
                                                <td>
                                                    <input type="number" class="form-control" value={crates[data.id]} onChange={(e)=>handleChange(e, data.id)} />
                                                </td>
                                                <td>
                                                    <button class="btn btn-sm btn-success" onClick={()=> updateCrates(data.id)}>Update</button>
                                                </td>
                                            </tr>
                                            )
                                        :
                                            <tr className="fw-400 text-gray-600  fs-12 text-center">
                                                <td colSpan={6}>No Data for Update</td>
                                            </tr>
                                        }
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
					</div>
				</div>
			</section>
		</div>
	</div>


        </>
    )

    
}

export default Service;